import { useNavigate } from "react-router-dom";
import Fb from "../../src/assets/svg/fb.svg";
import Instagram from "../../src/assets/svg/instagram.svg";
import YouTube from "../../src/assets/svg/youtube.svg";
import LogoBase from "../../src/assets/svg/logoBase.svg";

export function Footer() {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col justify-center w-full gap-6 px-6 py-10 bg-black border-t border-extra-light">
      <div className="flex flex-col w-full gap-6 px-6 pb-10 border-b border-white border-opacity-20">
        {/* Social media links */}
        <div className="flex items-center justify-center gap-2">
          <a
            href="https://www.facebook.com/PeugeotHrvatska/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={Fb} alt="Facebook"></img>
          </a>
          <a
            href="https://www.instagram.com/peugeothrvatska/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={Instagram} alt="Instagram"></img>
          </a>
          <a
            href="https://www.youtube.com/PeugeotHrvatska"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={YouTube} alt="YouTube"></img>
          </a>
        </div>

        {/* Logo */}
        <div className=" w-[80px] self-center">
          <img
            src={LogoBase}
            alt="Peugeot"
            onClick={() => {
              if (window.location.pathname === "/") {
                window.scrollTo({ top: 0, behavior: "smooth" });
              } else {
                navigate("/");
              }
            }}
            className="cursor-pointer"
          ></img>
        </div>

        {/* Legal links */}
        <div className="flex flex-col justify-center gap-3 sm:flex-row sm:gap-4">
          <div className="flex justify-center gap-3">
            <a
              href="https://www.peugeot.hr/korisne-informacije/politika-privatnosti.html"
              target="_blank"
              rel="noopener noreferrer"
              className="flex-1 text-xs font-medium text-right text-white opacity-70 text-nowrap"
            >
              Politika privatnosti
            </a>
            <div className="border border-white h-[13px] border-opacity-60"></div>
            <a
              href="https://www.peugeot.hr/korisne-informacije/pravne-informacije.html"
              target="_blank"
              rel="noopener noreferrer"
              className="flex-1 text-xs font-medium text-left text-white opacity-70 text-nowrap"
            >
              Pravne informacije
            </a>
          </div>
          <div className="hidden border border-white h-[13px] sm:flex border-opacity-60"></div>
          <div className="flex justify-center gap-3">
            <a
              href="https://www.peugeot.hr/korisne-informacije/cjenici.html"
              target="_blank"
              rel="noopener noreferrer"
              className="flex-1 text-xs font-medium text-center text-white opacity-70 text-nowrap"
            >
              Cjenici
            </a>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="flex max-w-[717px] justify-center self-center text-center gap-4 sm:text-[11px] text-[10px] text-white">
        P Automobil Import d.o.o.zadržava pravo da u bilo koje vrijeme, bez
        prethodne najave, ažurira ili izmijeni podatke na svojim web stranicama,
        osobito one koje se odnose na tehničke karakteristike, opremu
        predstavljenih modela i cijene, uzimajući u obzir interaktivni karakter
        stranice.
      </div>
    </div>
  );
}

export default Footer;
